import {
  //
  ADD_REVIEWS,
  ADD_REVIEWS_FAILURE,
  ADD_REVIEWS_SUCCESS,
  //
  DELETE_REVIEWS,
  DELETE_REVIEWS_FAILURE,
  DELETE_REVIEWS_SUCCESS,
  //
  EDIT_REVIEWS,
  EDIT_REVIEWS_FAILURE,
  EDIT_REVIEWS_SUCCESS,
  //
  FETCH_REVIEWS,
  FETCH_REVIEWS_FAILURE,
  FETCH_REVIEWS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_MOD_MODAL,
  //
  FETCH_UPLOADS,
  FETCH_UPLOADS_SUCCESS,
  FETCH_UPLOADS_FAILURE,
  //
  ADD_REVIEW_CARD,
  ADD_REVIEW_CARD_SUCCESS,
  ADD_REVIEW_CARD_FAILURE,
  //
  EDIT_REVIEW_CARD,
  EDIT_REVIEW_CARD_SUCCESS,
  EDIT_REVIEW_CARD_FAILURE,
  //
  GET_CARD_DATA,
  GET_CARD_DATA_SUCCESS,
  GET_CARD_DATA_FAILURE,
} from "./constants";

// List
export const fetchReviews = (payload) => ({
  type: FETCH_REVIEWS,
  payload,
});
export const fetchReviewsSuccess = (payload) => ({
  type: FETCH_REVIEWS_SUCCESS,
  payload,
});
export const fetchReviewsFailure = (payload) => ({
  type: FETCH_REVIEWS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addReviews = (payload) => ({
  type: ADD_REVIEWS,
  payload,
});
export const addReviewsSuccess = (payload) => ({
  type: ADD_REVIEWS_SUCCESS,
  payload,
});
export const addReviewsFailure = (payload) => ({
  type: ADD_REVIEWS_FAILURE,
  payload,
});
// EDIT
export const editReviews = (payload) => ({
  type: EDIT_REVIEWS,
  payload,
});
export const editReviewsSuccess = (payload) => ({
  type: EDIT_REVIEWS_SUCCESS,
  payload,
});
export const editReviewsFailure = (payload) => ({
  type: EDIT_REVIEWS_FAILURE,
  payload,
});
// DELETE
export const deleteReviews = (payload) => ({
  type: DELETE_REVIEWS,
  payload,
});
export const deleteReviewsSuccess = (payload) => ({
  type: DELETE_REVIEWS_SUCCESS,
  payload,
});
export const deleteReviewsFailure = (payload) => ({
  type: DELETE_REVIEWS_FAILURE,
  payload,
});
//
export const toggleModReview = (payload) => ({
  type: TOGGLE_MOD_MODAL,
  payload,
});

//
export const fetchUploads = (payload, onSuccess) => ({
  type: FETCH_UPLOADS,
  payload,
  onSuccess,
});
export const fetchUploadsSuccess = (payload) => ({
  type: FETCH_UPLOADS_SUCCESS,
  payload,
});
export const fetchUploadsFailure = (payload) => ({
  type: FETCH_UPLOADS_FAILURE,
  payload,
});

//
export const addReviewCard = (payload, onSuccess) => ({
  type: ADD_REVIEW_CARD,
  payload,
  onSuccess,
});
export const addReviewCardSuccess = (payload) => ({
  type: ADD_REVIEW_CARD_SUCCESS,
  payload,
});
export const addReviewCardFailure = (payload) => ({
  type: ADD_REVIEW_CARD_FAILURE,
  payload,
});

//
export const editReviewCard = (payload, onSuccess) => ({
  type: EDIT_REVIEW_CARD,
  payload,
  onSuccess,
});
export const editReviewCardSuccess = (payload) => ({
  type: EDIT_REVIEW_CARD_SUCCESS,
  payload,
});
export const editReviewCardFailure = (payload) => ({
  type: EDIT_REVIEW_CARD_FAILURE,
  payload,
});

//
export const getCardData = (payload, onSuccess) => ({
  type: GET_CARD_DATA,
  payload,
  onSuccess,
});
export const getCardDataSuccess = (payload) => ({
  type: GET_CARD_DATA_SUCCESS,
  payload,
});
export const getCardDataFailure = (payload) => ({
  type: GET_CARD_DATA_FAILURE,
  payload,
});
